import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { Roles } from './common/roles';
import { MapComponent } from './components/map/map.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { SplashComponent } from './components/splash/splash.component';
import { NgbdToastGlobal } from './components/toast-global/toast-global.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { CustomMsalGuard } from './guards/custom-msal.guard';
import { RoleGuard } from './guards/role.guard';
import { ServiceBypassMsalGuard } from './guards/service-bypass-msal.guard';

const routes: Routes = [
  {
    path: 'toast',
    component: NgbdToastGlobal
  },
  {
    path: 'auth',
    component: MsalRedirectComponent
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  },
  {
    path: 'splash',
    component: SplashComponent,
    canActivate: [ CustomMsalGuard ]
  },
  {
    path: '',
    pathMatch: 'full',
    component: MapComponent,
    canActivate: [ CustomMsalGuard, RoleGuard ],
    data: {
      rolesAllowed: Roles.GENERAL_APP_ACCESS
    }
  },
  {
    path: 'profile', 
    loadChildren: () => import('./modules/profile/profile.module').then((m) => m.ProfileModule),
    canActivate: [ ServiceBypassMsalGuard ]    
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // Don't perform initial navigation in iframes or popups
      initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' // Remove this line to use Angular Universal
    })
  ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
